import { Col, Input, Row, Select, Space } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { t } from 'i18next';
import React from 'react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PrimaryButton from '../../../../component/button/PrimaryButton';
import SecondaryButton from '../../../../component/button/SecondaryButton';
import { GROLOG_URL } from '../../../../constant/apiConstant';

const CompanyProfileCompletion = (props) => {
  const {grologAccInfo} = useSelector((state)=>state.page)
  const [title,setTitle] = useState([{value:"PT",label:"PT"},{value:"CV",label:"CV"}])
  // const [country, setCountry] = useState([]);
  // const [island, setIsland] = useState([]);
  // const [province, setProvince] = useState([]);
  // const [district, setDistrict] = useState([]);
  // const [subdistrict, setSubdistrict] = useState([]);
  // const [urbanvillage, setUrbanvillage] = useState([]);
  // const [postalcode, setPostalcode] = useState([]);
  const api = GROLOG_URL;
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${grologAccInfo.client_id}`;

  console.log("grolog acc", grologAccInfo);
  
  const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async (data) => {
    // getListCountry();
  }

  // const getListCountry = async () => {
  //   let country = await doGets(`/country?page=1&limit=50&${param}`, token);
  //   let list = [];
  //   country?.data?.payload?.data.map((el) => {
  //     list.push({
  //       value: el.id,
  //       label: el.name,
  //     });
  //   });
  //   setCountry(list);
  // };

  // const getListIsland = async (id) => {
  //   let island = await doGets(
  //     `/island?page=1&limit=50&order=id&filter=country_id eq ${id}&${param}`,
  //     token
  //   );
  //   let list = [];
  //   island?.data?.payload?.data.map((el) => {
  //     list.push({
  //       value: el.id,
  //       label: el.name,
  //     });
  //   });
  //   setIsland(list);
  // };

  // const getListProvince = async (id) => {
  //   let province = await doGets(
  //     `/province?page=1&limit=50&order=id&filter=country_id eq ${id}&${param}`,
  //     token
  //   );
  //   let list = [];
  //   province?.data?.payload?.data.map((el) => {
  //     list.push({
  //       value: el.id,
  //       label: el.name,
  //     });
  //   });
  //   setProvince(list);
  // };
  return (
    <>
      <div className='font-roboto font-semibold text-[20px]'>
        {t("LOGIN_COMPLETION:TITLE_LAYOUT")}
      </div>

      <Row>
        <Col span={10}>
          <div className='font-roboto-medium text-[18px] font-medium mt-3'>
            {t("LOGIN_COMPLETION:PERSONAL_INFORMATION")}
          </div>
        </Col>
        <Col span={4}></Col>
        <Col span={10}>
          <div className='font-roboto-medium text-[18px] font-medium mt-3'>
            {t("LOGIN_COMPLETION:ADDRESS_INFORMATION")}
          </div>
        </Col>
      </Row>

      <Row className='mt-3'>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COMPANY_TITLE")}
              </p>
              <Select 
                style={{ width: '100%' }} 
                size='large'
                value={props?.form?.company_title}
                options={title}
                onChange={(value)=>props.handleChange(value,"company_title")}
                placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_COMPANY_TITLE")} )}
                status={props?.error?.company_title ? "error" : ""}
                />
                <div className="text-red-100">{props?.error?.company_title}</div>
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COMPANY_NAME")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large' 
                value={props?.form?.company_name}
                onChange={(value)=>props.handleChange(value,"company_name")}
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_COMPANY_NAME")} )}
                status={props?.error?.company_name ? "error" : ""}
                />
                <div className="text-red-100">{props?.error?.company_name}</div>
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COMPANY_PHONE")}
              </p>
              <Space>
                <Space.Compact size='large'>
                  <Input
                    style={{ width: '25%' }} 
                    size='large'
                    placeholder="+62"
                    disabled
                  />
                  <Input 
                    style={{ width: '100%' }} 
                    size='large'
                    value={props?.form?.company_phone}
                    status={props?.error?.company_phone ? "error" : ""}
                    onChange={(value)=>props.handleChange(value,"company_phone")}
                    placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_COMPANY_PHONE")} )}
                  />
                </Space.Compact>
              </Space>
                <div className="text-red-100">{props?.error?.company_phone}</div>
            </div>
          </Col>
          <Col span={4}> </Col>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COUNTRY")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={props?.form?.company_country}
                onChange={(value)=>props.handleChange(value,"company_country")}
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_COUNTRY")} )}
                status={props?.error?.company_country ? "error" : ""}
                />
                <div className="text-red-100">{props?.error?.company_country}</div>
              
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_PROVINCE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={props?.form?.company_province}
                onChange={(value)=>props.handleChange(value,"company_province")}
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_PROVINCE")} )}
                status={props?.error?.company_province ? "error" : ""}
                />
                <div className="text-red-100">{props?.error?.company_province}</div>
            
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_ADDRESS")}
              </p>
              <TextArea 
                style={{ width: '100%' }} 
                size='large'
                value={props?.form?.company_address}
                onChange={(value)=>props.handleChange(value,"company_address")}
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_ADDRESS")} )}
                status={props?.error?.company_address ? "error" : ""}
                />
                <div className="text-red-100">{props?.error?.company_address}</div>
              
            </div>
          </Col>
        </Row>

    </>
  );
};

export default CompanyProfileCompletion;